import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from 'recharts';
import { Box, Text } from 'grommet';

const SearchEnginePieChart = ({
  data,
  primaryText = 'var(--page-primary-text)',
  secondaryText = 'var(--page-secondary-text)',
  chartTooltip,
}) => {
  const colors = ['#1687D9', '#FF6B35'];
  return (
    <Box direction="column" gap="1rem">
      <Box direction="column" gap="0.5rem">
        <Text color={primaryText} size="1rem" weight={700}>
          Search Engine Discovery
        </Text>
        <Text color={secondaryText} size="0.8rem">
          Google and Bing discovery coverage across detected infringement URLs.
        </Text>
      </Box>
      <Box height="19rem" width="100%">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="urls"
              nameKey="source"
              cx="50%"
              cy="48%"
              outerRadius={85}
              innerRadius={42}
              paddingAngle={4}
            >
              {data.map((entry, index) => (
                <Cell key={entry.source} fill={colors[index % colors.length]} />
              ))}
            </Pie>
            <Tooltip {...chartTooltip} />
            <Legend verticalAlign="bottom" />
          </PieChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

SearchEnginePieChart.propTypes = {
  data: PropTypes.array.isRequired,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
  chartTooltip: PropTypes.object.isRequired,
};

export default SearchEnginePieChart;
